import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'

import { toURL } from './'
import { AuthStatusEnum } from '../auth/withAuthStatus'
import AppPage from '../../components/pages/AppPage'
import LoginPage from '../../components/pages/LoginPage'

export const RootRoutes = {
  home: 'home',
  login: 'login',
}

const RootPaths = {
  home: '/',
  login: '/login',
}

export function toPath(route) {
  switch (route) {
    case RootRoutes.login:
      return RootPaths.login
    case RootRoutes.home:
    default:
      return RootPaths.home
  }
}

export function toRoute(pathname) {
  const url = toURL(pathname)
  if (url.path.length === 1 && url.path[0] === 'login') return RootRoutes.login
  else return RootRoutes.home
}

function shouldRedirect(location, authStatus) {
  const route = toRoute(location)
  if (authStatus === AuthStatusEnum.authorized && route === RootRoutes.login) {
    return '/'
  } else if (
    authStatus === AuthStatusEnum.unauthorized &&
    route === RootRoutes.home
  ) {
    return '/login'
  }

  return undefined
}

function redirectRouteIfNeeded(location, redirect, authStatus) {
  const redirectTarget = shouldRedirect(location, authStatus)
  if (redirectTarget) redirect(redirectTarget)
}

class RootRouter extends React.Component {
  componentDidMount() {
    this.props.history.listen((location, action) =>
      redirectRouteIfNeeded(
        location,
        this.props.history.replace,
        this.props.authStatus,
      ),
    )
    redirectRouteIfNeeded(
      this.props.location,
      this.props.history.replace,
      this.props.authStatus,
    )
  }

  renderAppPage = () => <AppPage userId={this.props.userId} />

  render() {
    const { authStatus } = this.props
    return (
      <Switch>
        {authStatus === AuthStatusEnum.authorized && (
          <Route path={RootPaths.home} component={this.renderAppPage} />
        )}
        {authStatus === AuthStatusEnum.unauthorized && (
          <Route path={RootPaths.login} component={LoginPage} />
        )}
      </Switch>
    )
  }
}

export default withRouter(RootRouter)



// WEBPACK FOOTER //
// ./src/modules/router/RootRouter.js